module.exports = require("axios");


//////////////////
// WEBPACK FOOTER
// external "axios"
// module id = 19
// module chunks = 0